import { motion } from "framer-motion"
import { Link } from "react-router-dom"
import { MapPin } from "react-feather"
import { lazy, Suspense } from "react"
import { PAGE_URLS } from "../../constants/page-urls"
const HotSpotMap = lazy(() => import("../HotspotMap/HotSpotMap"))
const containerVariants = {
    rest: {},
    hover: {
        transition: {
            staggerChildren: 0.2,
        },
    },
}

const cardVariants = {
    rest: { scale: 0.8, rotate: 5, x: 80, y: 50 },
    hover: { scale: 1, rotate: 5, x: 0 },
    repeating: {
        scale: 1,
        rotate: -20,
        x: 100,
        y: 0,
        transition: {
            ease: "easeOut",
            duration: 0.5,
        },
    },
}

const mapVariants = {
    rest: { scale: 0, rotate: 45, y: 0, X: 0 },
    hover: { scale: 1, rotate: 15, y: -10, x: 10 },
    repeating: {
        scale: 1.2,
        rotate: 15,
        y: -20,
        x: 10,
        transition: {
            delay: 0.5,
            type: "spring",
            stiffness: 500,
            damping: 15,
        },
    },
}

const MapArticle = () => {
    return (
        <div className="py-24">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-24 gap-y-16 max-w-6xl mx-auto px-4 ">
                <div className="order-2 lg:order-1">
                    <motion.div
                        style={{ willChange: "transform" }}
                        variants={containerVariants}
                        initial="rest"
                        animate="rest"
                        whileInView="repeating"
                        viewport={{ once: true, margin: "-30%" }}
                        className="aspect-square max-w-sm relative mx-auto"
                    >
                        <div className="absolute top-4 left-4 w-full h-full ">
                            <svg
                                width="100%"
                                className="-translate-x-4"
                                viewBox="0 0 160 136"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M118.9 0.399964C133.8 -1.00004 147.1 11.1 154 26.1C160.9 41.1 161.4 59.1 156.6 74.6C151.7 90.1 141.5 103.2 130.3 114.4C119.1 125.6 106.8 134.8 94.0001 135.5C81.2001 136.2 67.8001 128.3 56.2001 121.6C44.5001 115 34.6001 109.6 25.0001 101.9C15.3001 94.3 6.00012 84.5 2.30012 72.6C-1.39988 60.7 0.500114 46.7 5.50011 33.4C10.5001 20 18.4001 7.29996 29.8001 7.09996C41.3001 6.89996 56.1001 19.2 71.8001 17.9C87.5001 16.7 104 1.79996 118.9 0.399964Z"
                                    fill="#f0573e"
                                />
                            </svg>
                        </div>
                        <motion.div
                            variants={mapVariants}
                            className="absolute top-4 right-4 flex rotate-45 justify-center items-center z-10"
                        >
                            <MapPin className="size-24  text-primary-600 fill-primary-400" />
                        </motion.div>
                        <motion.div
                            variants={cardVariants}
                            className="relative h-full w-full"
                        >
                            <div className="absolute left-1/2  -translate-x-1/2 h-full aspect-[7/12] border border-neutral-700 bg-neutral-700 overflow-hidden rounded-2xl shadow-xl">
                                <div className="relative w-full h-full ">
                                    <div className="absolute left-2 right-0 top-0 bottom-2 bg-neutral-800 rounded-xl flex flex-col p-2">
                                        <div className="flex-1 bg-gradient-to-br from-primary-200 to-primary-400 rounded-lg overflow-hidden flex justify-center items-center relative">
                                            <div className="scale-150 rotate-12">
                                                <Suspense>
                                                    <HotSpotMap />
                                                </Suspense>
                                            </div>
                                        </div>
                                        <div className="absolute top-0 h-4 w-24 bg-neutral-800 rounded-full left-1/2 -translate-x-1/2"></div>
                                        <div className="absolute bottom-4 h-1 w-24 bg-white rounded-full left-1/2 -translate-x-1/2"></div>
                                    </div>
                                </div>
                            </div>
                        </motion.div>
                    </motion.div>
                </div>

                <div className="flex flex-col justify-center gap-4 max-w-lg mx-auto lg:order-2">
                    <h1 className="text-3xl font-bold fg-color-1">
                        Företagen på Kartan
                    </h1>
                    <p className="text-lg fg-color-2 leading-8 max-w-[45ch]">
                        Gå inte vilse i monterdjungeln. Hitta snabbt och smidigt
                        det företag du söker på kartan.
                    </p>
                    <div className=" sm:block w-full lg:w-auto pt-2 flex">
                        <div className="flex">
                            <Link
                                to={PAGE_URLS.MAP}
                                className="block  p-4 px-12 bg-gradient-to-br from-primary-400 to-primary-500 inset-0 text-white font-semibold text-center rounded-lg "
                            >
                                Till Kartan
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MapArticle
